/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to true if you want to use the splash screen.
  useCustomCursor: true, // Change this to false if you want the good'ol cursor
  googleTrackingID: "G-GC94HDTH10",
};

//Home Page
const greeting = {
  title: "Hey there! 👋",
  title2: "Vijay",
  logo_name: "svijayb.dev()",
  nickname: "vijay / 3fbc",
  full_name: "S Vijay Balaji",
  subTitle:
    "a Data Science aspirant. I live by the words of Steve Jobs, “The only way to do great work is to love what you do.” This belief shaped my journey, turning my passion into purpose and purpose into profession. ✨",
  resumeLink: "/resume.pdf",
  mail: "mailto:svijayb.dev@gmail.com",
};

const socialMediaLinks = {
  /* Your Social Media Link */
  github: "https://github.com/svijayb",
  linkedin: "https://www.linkedin.com/in/svijayb/",
  gmail: "svijayb.dev@gmail.com",
  twitter: "https://twitter.com/VijaybalajiS1",
  instagram: "https://www.instagram.com/svijayb.jpeg/",
  hackerrank: "https://www.hackerrank.com/profile/svijayb",
  youtube: "/youtube",
};

const darkModeIconStyle = {
  backgroundColor: "#f0f0f0",
  borderRadius: "50%",
  padding: "5px",
};

const skills = {
  data: [
    {
      title: "Data Science & AI",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Building efficient, high-performance models for various deep learning and statistical tasks.",
        "⚡ Proficient in advanced Computer Vision and Natural Language Processing (NLP).",
        "⚡ Expertise in sophisticated quantitative modeling for predictive forecasting and time series analysis.",
      ],
      softwareSkills: [
        {
          skillName: "Tensorflow",
          fontAwesomeClassname: "logos-tensorflow",
          style: darkModeIconStyle,
        },
        {
          skillName: "Keras",
          fontAwesomeClassname: "devicon:keras",
          style: darkModeIconStyle,
        },
        {
          skillName: "PyTorch",
          fontAwesomeClassname: "devicon:pytorch",
          style: darkModeIconStyle,
        },
        {
          skillName: "Scikit-learn",
          fontAwesomeClassname: "devicon:scikitlearn",
          style: darkModeIconStyle,
        },
        {
          skillName: "Pandas",
          fontAwesomeClassname: "devicon:pandas",
          style: darkModeIconStyle,
        },
        {
          skillName: "NumPy",
          fontAwesomeClassname: "logos-numpy",
          style: darkModeIconStyle,
        },
        {
          skillName: "Apache Spark",
          fontAwesomeClassname: "logos:apache-spark",
          style: {
            backgroundColor: "#f0f0f0",
            borderRadius: "5px",
            padding: "3px",
          },
        },
        {
          skillName: "Power BI",
          fontAwesomeClassname: "logos:microsoft-power-bi",
          style: darkModeIconStyle,
        },
        {
          skillName: "Tableau",
          fontAwesomeClassname: "logos:tableau-icon",
          style: darkModeIconStyle,
        },
        {
          skillName: "Matplotlib",
          fontAwesomeClassname: "devicon:matplotlib",
          style: darkModeIconStyle,
        },
        {
          skillName: "OpenCV",
          fontAwesomeClassname: "logos:opencv",
          style: darkModeIconStyle,
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "logos-python",
          style: darkModeIconStyle,
        },
        {
          skillName: "Jupyter",
          fontAwesomeClassname: "logos:jupyter",
          style: darkModeIconStyle,
        },
      ],
    },
    {
      title: "Full Stack Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Develop robust and scalable backend applications using Flask, Django, and Node.js",
        "⚡ Design and implement RESTful and GraphQL APIs for seamless client-server communication",
        "⚡ Enhance database performance and integrity through Redis and caching strategies, alongside diverse database utilization.",
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "devicon:html5",
          style: darkModeIconStyle,
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "devicon:css3",
          style: darkModeIconStyle,
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "logos:javascript",
          style: darkModeIconStyle,
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "logos:nodejs",
          style: {
            backgroundColor: "#f0f0f0",
            borderRadius: "5px",
            padding: "3px",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "devicon:react",
          style: darkModeIconStyle,
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "logos-python",
          style: darkModeIconStyle,
        },
        {
          skillName: "Django",
          fontAwesomeClassname: "material-icon-theme:django",
          style: darkModeIconStyle,
        },
        {
          skillName: "Flask",
          fontAwesomeClassname: "devicon:flask",
          style: darkModeIconStyle,
        },
        {
          skillName: "Java",
          fontAwesomeClassname: "devicon:java",
          style: darkModeIconStyle,
        },
        {
          skillName: "C++",
          fontAwesomeClassname: "devicon:cplusplus",
          style: darkModeIconStyle,
        },
        {
          skillName: "PostgreSQL",
          fontAwesomeClassname: "logos:postgresql",
          style: darkModeIconStyle,
        },
        {
          skillName: "MySQL",
          fontAwesomeClassname: "logos:mysql",
          style: darkModeIconStyle,
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "vscode-icons:file-type-mongo",
          style: darkModeIconStyle,
        },
        {
          skillName: "GraphQL",
          fontAwesomeClassname: "logos:graphql",
          style: darkModeIconStyle,
        },
        {
          skillName: "Redis",
          fontAwesomeClassname: "devicon:redis",
          style: darkModeIconStyle,
        },
        {
          skillName: "Git",
          fontAwesomeClassname: "devicon:git",
          style: darkModeIconStyle,
        },
      ],
    },
    {
      title: "Cloud Infra-Architecture",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Experience in setting up CI/CD pipelines for seamless deployment workflows",
        "⚡ Engaged in infrastructure automation through Ansible playbooks, streamlining server management processes.",
        "⚡ Leveraged Terraform for infrastructure-as-code practices, automating tasks critical for disaster recovery.",
        "⚡ Led migration initiatives from traditional VM hosting to Kubernetes, optimizing application scalability and resource efficiency.",
      ],
      softwareSkills: [
        {
          skillName: "Azure",
          fontAwesomeClassname: "devicon:azure",
          style: darkModeIconStyle,
        },
        {
          skillName: "AWS",
          fontAwesomeClassname: "logos:aws",
          style: {
            backgroundColor: "#f0f0f0",
            borderRadius: "5px",
            padding: "3px",
          },
        },
        {
          skillName: "Azure DevOps",
          fontAwesomeClassname: "devicon:azuredevops",
          style: darkModeIconStyle,
        },
        {
          skillName: "GitHub Actions",
          fontAwesomeClassname: "devicon:githubactions",
          style: darkModeIconStyle,
        },
        {
          skillName: "Jenkins",
          fontAwesomeClassname: "devicon:jenkins",
          style: darkModeIconStyle,
        },
        {
          skillName: "Netlify",
          fontAwesomeClassname: "devicon:netlify",
          style: darkModeIconStyle,
        },
        {
          skillName: "Firebase",
          fontAwesomeClassname: "logos:firebase",
          style: darkModeIconStyle,
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "logos:docker-icon",
          style: darkModeIconStyle,
        },
        {
          skillName: "Kubernetes",
          fontAwesomeClassname: "logos:kubernetes",
          style: darkModeIconStyle,
        },
        {
          skillName: "Terraform",
          fontAwesomeClassname: "devicon:terraform",
          style: darkModeIconStyle,
        },
        {
          skillName: "Ansible",
          fontAwesomeClassname: "vscode-icons:file-type-ansible",
          style: darkModeIconStyle,
        },
        {
          skillName: "Prometheus",
          fontAwesomeClassname: "logos:prometheus",
          style: darkModeIconStyle,
        },
        {
          skillName: "Grafana",
          fontAwesomeClassname: "logos:grafana",
          style: darkModeIconStyle,
        },
        {
          skillName: "Kibana",
          fontAwesomeClassname: "devicon:kibana",
          style: darkModeIconStyle,
        },
      ],
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "University of Washington, Seattle",
      subtitle: "Master of Science in Data Science",
      logo_path: "UW.png",
      alt_name: "UW",
      duration: "2024 - 2026",
      descriptions: [
        "Graduated witha Master of Science in Data Science at the University of Washington with a GPA of 3.9/4.0",
        "It's an interdisciplinary curriculum that blends theory with hands-on learning across ML, Stats, Software design, and Data visualization.",
        "Worked on several projects and had our final capstone in collaboration with Microsoft, where we built Sequel2SQL."
      ],
      website_link: "https://www.washington.edu/datasciencemasters/",
    },
    {
      title: "Vellore Institute of Technology (VIT-AP)",
      subtitle: "Bachelor of Technology in Computer Science Engineering",
      logo_path: "VIT.png",
      alt_name: "VIT",
      duration: "2019 - 2023",
      descriptions: [
        "Took up various Data Science electives and earned a Big Data Analytics certification.",
        "Promoted to lead a club, held several solo workshops on topics covering Git, GitHub and Linux",
        "Conducted and published patented research in the Mathematics journal.",
        "Graduated with a CGPA of 9.3.",
      ],
      website_link: "https://www.vitap.ac.in/",
    },
    {
      title: "Narayana PU/CBSE College",
      subtitle: "Senior Secondary High School",
      logo_path: "narayana.png",
      alt_name: "Narayana",
      duration: "2017 - 2019",
      descriptions: [
        "Studied PCMC, scoring 96% in junior year and 87% in senior year in Computer science. ",
        "Learnt C++, MySQL and other core programming concepts like Data Structures and OOPS here.",
      ],
      website_link: "https://www.narayanagroup.com/",
    },
    {
      title: "Geethanjali Vidyalaya",
      subtitle: "Primary and High School",
      logo_path: "GV.png",
      alt_name: "GV",
      duration: "2006 - 2017",
      descriptions: [
        "Led the science club, enabled scientific curiosity, with an emphasis on computer science.",
        "Participated in several competitions, securing runner-up in ISRO extempore and earned the Best performer award at Times NIE playfest.",
        "Scored a perfect 10 CGPA, showcasing academic excellence and setting a strong foundation for future studies",
      ],
      website_link: "http://geevid.org/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Runner-up at Hackathon",
      subtitle: "UW MSDS Hackathon '24",
      logo_path: "msds.png",
      certificate_link:
        "https://drive.google.com/file/d/1PeOBsN_DFbAT4v1Gh-3tYDciGXjN7Srl/view?usp=sharing",
      alt_name: "MSDS Hackathon",
      color_code: "#BAA4E3",
    },
    {
      title: "Azure Fundamentals",
      subtitle: "Microsoft",
      logo_path: "azure.png",
      certificate_link:
        "https://drive.google.com/file/d/1n0lCdQewo-Rht34aup1jbtJ1Lkxrj7_C/view?usp=sharing",
      alt_name: "Azure Fundamentals",
      color_code: "#E0F7FF",
    },
    {
      title: "Big Data Foundation",
      subtitle: "Nasscom",
      logo_path: "nasscom.png",
      certificate_link:
        "https://drive.google.com/file/d/1-z7L7Zti6cgBQdpY4Fp3ybK4KoWhaJt8/view?usp=sharing",
      alt_name: "Nasscom",
      color_code: "#FFE6E1",
    },
    {
      title: "Agile Scrum Master",
      subtitle: "Udemy Certification",
      logo_path: "udemy.png",
      certificate_link:
        "https://drive.google.com/file/d/1WUajtwb7X2wPkYsQEqfu2MdoSD259ngt/view?usp=sharing",
      alt_name: "Udemy",
      color_code: "#F3E6FF",
    },
    {
      title: "Runner-up at Hackathon",
      subtitle: "NMIT Hacks 2022",
      logo_path: "nmit.png",
      certificate_link:
        "https://drive.google.com/file/d/1psjmVkFbRxHnE1OpIHl-707YPIp08ZYe/view?usp=sharing",
      alt_name: "NMIT Hacks",
      color_code: "#FFDAB9",
    },
    {
      title: "WSoC 2020 Mentor",
      subtitle: "Open Source Community",
      logo_path: "wsoc.png",
      certificate_link:
        "https://drive.google.com/file/d/1iT_FbL2uXm532b8ubyl43iK1HqgO49IV/view?usp=sharing",
      alt_name: "WSoC",
      color_code: "#89CFF0",
    },
    {
      title: "Academic Support Volunteer",
      subtitle: "Make A Difference (MAD)",
      logo_path: "mad-logo.png",
      certificate_link:
        "https://drive.google.com/file/d/1i60WBuSdubQpKxGn8L-JFcvg2zhgNmOw/view?usp=sharing",
      alt_name: "MAD",
      color_code: "#FFCCCC",
    },
    {
      title: "Rest API (Intermediate)",
      subtitle: "HackerRank Certification",
      logo_path: "hackerrank.png",
      certificate_link: "https://www.hackerrank.com/certificates/66ed64783462",
      alt_name: "hackerrank",
      color_code: "#AFEEEE",
    },
    {
      title: "MLH Local Hack Day: Build",
      subtitle: "Major League Hacking",
      logo_path: "mlh-logo.png",
      certificate_link:
        "https://drive.google.com/file/d/1LkhUcf8DiU3nX6nIuLjX5Ky9HU6ql99Y/view?usp=sharing",
      alt_name: "hackerrank",
      color_code: "#E8F8F5",
    },
    {
      title: "Extempore Sci Elocution",
      subtitle: "Indian Space Research Organisation",
      logo_path: "isro.png",
      certificate_link:
        "https://drive.google.com/file/d/1TjsdoNfH5PkfSD9J1SCMsYstLN3T549T/view?usp=sharing",
      alt_name: "isro",
      color_code: "#E6E6FA",
    },
    {
      title: "Times NIE Playfest",
      subtitle: "The Times of India",
      logo_path: "toi-nie.png",
      certificate_link:
        "https://drive.google.com/file/d/1SIxNfC5WbQCAwDCB90xwCbqjMhhy8ZoH/view?usp=sharing",
      alt_name: "nie-playfest",
      color_code: "#F5F5F5",
    },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work, Internship and Volunteership",
  description: `I have experience in various domains of Computer science, including SWE, DevOps, ML and DL.
    Passionate about open-source, I've fostered communities, organized events, and mentored teams, driving impactful contributions throughout.`,
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work Experience",
      experiences: [
        {
          title: "Incoming SDE (AI/ML) Intern",
          company: "Amazon AWS",
          company_url: "https://aws.amazon.com/",
          logo_path: "amazon_aws.png",
          duration: "Jun 2025 - Sep 2025",
          location: "Seattle, US",
          description: `Incoming SDE intern at Amazon AWS.
                        More info to be updated soon!`,
        },
        {
          title: "DevOps Engineer",
          company: "Fareportal",
          company_url: "https://fareportal.com/",
          logo_path: "fareportal.png",
          duration: "Oct 2022 - Jul 2024",
          location: "Remote",
          description: `Set up CI/CD pipelines on Azure DevOps for seamless deployment workflows.
                        Wrote Ansible playbooks to automate several aspects of server infrastructure.
                        Assisted in migrating VM applications to Kubernetes.
                        Worked with ActiveBatch for application automation and scheduling.
                        Built projects for automating tasks during disaster recovery using Terraform.`,
        },
        {
          title: "Technical Content Writer (Internship)",
          company: "Tutorialspoint",
          company_url: "https://www.tutorialspoint.com/",
          logo_path: "tutorialspoint.png",
          duration: "Mar 2021 - Jul 2021",
          location: "Remote",
          description: `Interned at Tutorialspoint as a technical content writer,
                        created and submitted over 200 detailed articles on Python and its libraries.
                        Provided comprehensive answers to community queries through well-defined articles in the Q&A section.`,
        },
        {
          title: "Deep Learning Intern",
          company: "Artificial Intelligence and Robotic (AIR) Center VIT-AP",
          company_url: "https://www.vitap.ac.in/ai-robotics-center",
          logo_path: "VIT.png",
          duration: "Aug 2020 - Sep 2020",
          location: "Remote",
          description: `Worked on image classification, object detection, and various machine learning image recognition models, specifically InceptionV3.
                        Deployed trained models to the cloud for easier accessibility
                        Developed a fully functional, production-ready product capable of identifying retail products with over 97% accuracy.`,
        },
      ],
    },
    {
      title: "Volunteerships",
      experiences: [
        {
          title: "Community Lead",
          company: "Open Source Community VIT-AP",
          company_url: "https://oscvitap.org/",
          logo_path: "osc.png",
          duration: "Sep 2019 - May 2022",
          location: "Amaravati",
          description: `Joined the Open Source Community in my freshman year as PR head and organized major events like MLH Build 2019 and Software Freedom Day 2020.
            Advanced to Vice President role in sophomore year, held several solo workshops on Git, GitHub and Linux, led the Winter Season of Code initiative.
            Got promoted to Community Leader in my junior year, led a team of 20+ members, organized impactful FOSS events, and actively contributed to various tech projects.`,
        },
        {
          title: "Mozilla Campus Captain",
          company: "Mozilla",
          company_url: "https://community.mozilla.org/en/",
          logo_path: "mozilla.png",
          duration: "May 2021 - May 2022",
          location: "Amaravati",
          description: `Role involved establishing an open-source culture within the university. 
            Organized numerous events promoting Free and Open Source Software (FOSS), including hackathons focused on challenges sourced from the local community. 
            Managed to create a thriving open-source community within the college campus.`,
        },
        {
          title: "Academic Support Volunteer",
          company: "Make A Difference (MAD)",
          company_url: "https://makeadiff.in/",
          logo_path: "mad.png",
          duration: "Nov 2021 - May 2022",
          location: "Bangalore",
          description: `Provided academic support for students from 5th grade to 10th grade. 
            Took sessions/classes on the Science curriculum. 
            My main objective was to provide a strong knowledge base for the children in order for them to have a more productive and stable future.`,
        },
        {
          title: "Winter Season of Code Mentor",
          company: "Open Source Community",
          company_url: "https://wsoc.oscvitap.org/",
          logo_path: "wsoc-icon.png",
          duration: "Dec 2020 - Feb 2021",
          location: "Amaravati",
          description: `Project Mentor at WSoC, where I led a four member developer team, setting up a clear sprint roadmap.
          Ran weekly stand‑ups, code‑review sessions, and pair‑programming, coaching the team on Django best‑practices, Git workflows, and test‑driven development. 
          Outcome: the team shipped a cross‑platform production ready application that logs desktop app usage, analyzes activity patterns, and can block distracting apps that help them stay focused.`,
        },
        {
          title: "Developer Program Member",
          company: "GitHub",
          company_url: "https://github.com/svijayb",
          logo_path: "github.png",
          duration: "Sep 2019 - Present",
          location: "Remote",
          description: `I actively contribute to several open-source projects and maintain repositories that provide foundational learning materials for programming languages, ranging from basic to advanced levels. 
          These repositories include comprehensive documentation and code examples for practical learning.
          I have also made substantial contributions to organizations and projects, including bug fixes, feature requests, and detailed documentation.`,
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects utilize a wide array of cutting-edge tools and technologies, typically focusing on data science, automation scripts, APIs, and microservices.",
  avatar_image_path: "projects_image.svg",
};

const projects = {
  data: [
    {
      id: "1",
      name: "Quizzatron",
      url: "https://github.com/SVijayB/Quizzatron",
      description:
        "Built an AI-powered quizzing platform that generates custom, gamified quizzes from text, images, PDFs or AI models using both user input and open-source trivia data.",
      category: "Data Science",
      languages: [
        {
          name: "Python",
          iconifyClass: "logos:python",
        },
        {
          name: "Flask",
          iconifyClass: "simple-icons:flask",
        },
        {
          name: "ReactJS",
          iconifyClass: "logos-react",
        },
        {
          name: "Gemini API",
          iconifyClass: "logos:google-gemini",
        },
      ],
      links: [
        {
          name: "Github",
          url: "https://github.com/SVijayB/Quizzatron",
          iconifyClass: "ri:github-fill",
        },
        {
          name: "Website",
          url: "https://quizzatron.netlify.app/",
          iconifyClass: "mdi:web",
        },
      ],
    },
    {
      id: "2",
      name: "RentQuest",
      url: "https://github.com/SVijayB/RentQuest",
      description:
        "A smart rental recommender that suggests apartments based on safety, proximity to public amenities, and lets users input up to 3 locations (e.g. work, school) to find the most optimally located home. Won runner-up at the UW MSDS Hackathon!",
      category: "Data Science",
      languages: [
        {
          name: "Python",
          iconifyClass: "logos:python",
        },
        {
          name: "Flask",
          iconifyClass: "simple-icons:flask",
        },
        {
          name: "Maps API",
          iconifyClass: "logos:google-maps",
        },
        {
          name: "HTML5",
          iconifyClass: "logos-html-5",
        },
        {
          name: "CSS3",
          iconifyClass: "logos-css-3",
        },
      ],
      links: [
        {
          name: "Github",
          url: "https://github.com/SVijayB/RentQuest",
          iconifyClass: "ri:github-fill",
        },
      ],
    },
    {
      id: "3",
      name: "SteamViz",
      url: "https://public.tableau.com/views/SteamViz/GameExplorer?:language=en-US&:sid=&:redirect=auth&:display_count=n&:origin=viz_share_link",
      description:
        "A visual game explorer that recommends the top 100 Steam games based on PC specs, and uncovers gaming trends by analyzing genre wise revenue, playtime, downloads, and user behavior.",
      category: "Data Science",
      languages: [
        {
          name: "Python",
          iconifyClass: "logos:python",
        },
        {
          name: "Tableau",
          iconifyClass: "logos:tableau-icon",
        },
      ],
      links: [
        {
          name: "Visualization",
          url: "https://public.tableau.com/app/profile/vijay.balaji.sankara.narayanan/viz/SteamViz/GameExplorer",
          iconifyClass: "mdi:web",
        },
      ],
    },
    {
      id: "4",
      name: "Gist",
      url: "https://github.com/SVijayB/Gist",
      description:
        "An abstractive style text summarizer emphasizing on news summarization and classification. Won runner up as part of NMIT Hacks 2022.",
      category: "Data Science",
      languages: [
        {
          name: "Python",
          iconifyClass: "logos:python",
        },
        {
          name: "Flask",
          iconifyClass: "simple-icons:flask",
        },
        {
          name: "HuggingFace Transformers",
          iconifyClass: "logos:hugging-face-icon",
        },
        {
          name: "MongoDB",
          iconifyClass: "logos:mongodb-icon",
        },
        {
          name: "ReactJS",
          iconifyClass: "logos-react",
        },
      ],
      links: [
        {
          name: "Github",
          url: "https://github.com/SVijayB/Gist",
          iconifyClass: "ri:github-fill",
        },
      ],
    },
    {
      id: "5",
      name: "Terraform-DR-MSSQL-Backup",
      url: "https://github.com/SVijayB/Terraform-scripts",
      description:
        "Terraform project that automates data restoration from Azure Blob Storage to a newly provisioned MSSQL VM, designed for disaster recovery scenarios.",
      category: "DevOps/Automation",
      languages: [
        {
          name: "Terraform",
          iconifyClass: "devicon:terraform",
        },
        {
          name: "Azure",
          iconifyClass: "devicon:azure",
        },
        {
          name: "PowerShell",
          iconifyClass: "devicon:powershell",
        },
        {
          name: "Azure DevOps",
          iconifyClass: "devicon:azuredevops",
        },
      ],
      links: [
        {
          name: "Github",
          url: "https://github.com/SVijayB/Terraform-scripts",
          iconifyClass: "ri:github-fill",
        },
      ],
    },
    {
      id: "6",
      name: "DocCompare",
      url: "https://www.mdpi.com/1944880",
      description:
        "Developed a patented solution to prevent character injection in document similarity algorithms using k-grams. Published a paper in the Mathematics journal.",
      category: "Data Science",
      languages: [
        {
          name: "Python",
          iconifyClass: "logos:python",
        },
        {
          name: "OpenCV",
          iconifyClass: "logos:opencv",
        },
        {
          name: "Django",
          iconifyClass: "simple-icons:django",
        },
        {
          name: "ReactJS",
          iconifyClass: "logos-react",
        },
      ],
      links: [
        {
          name: "Publication",
          url: "https://www.mdpi.com/1944880",
          iconifyClass: "jam:write-f",
        },
        {
          name: "Front-end",
          url: "https://doccompare-test.netlify.app/",
          iconifyClass: "mdi:web",
        },
      ],
    },
    {
      id: "7",
      name: "Productivity Tracker",
      url: "https://github.com/kevalvavaliya/Adoptisity",
      description:
        "An analytics tool that tracks user activity on desktops, offering detailed insights into app usage and time spent, leading to increased productivity",
      category: "Data Science",
      languages: [
        {
          name: "Python",
          iconifyClass: "logos:python",
        },
        {
          name: "Django",
          iconifyClass: "simple-icons:django",
        },
        {
          name: "HTML5",
          iconifyClass: "logos-html-5",
        },
        {
          name: "CSS3",
          iconifyClass: "logos-css-3",
        },
      ],
      links: [
        {
          name: "Github",
          url: "https://github.com/osc-vitap/Productivity-tracker",
          iconifyClass: "ri:github-fill",
        },
      ],
    },

    {
      id: "8",
      name: "OSC-API",
      url: "https://github.com/osc-vitap/OSC-API",
      description:
        "Built a centralized API for the open-source community, serving all the required content for their main website, automating event notifications via Discord bot, and more!",
      category: "Web Development",
      languages: [
        {
          name: "Python",
          iconifyClass: "logos:python",
        },
        {
          name: "Flask",
          iconifyClass: "simple-icons:flask",
        },
        {
          name: "MongoDB",
          iconifyClass: "logos:mongodb-icon",
        },
      ],
      links: [
        {
          name: "Github",
          url: "https://github.com/osc-vitap/OSC-API",
          iconifyClass: "ri:github-fill",
        },
      ],
    },
    {
      id: "9",
      name: "OSC-DBot",
      url: "https://github.com/osc-vitap/OSC-DBot",
      description:
        "Built a Discord bot for the open source community to increase server engagement with discussion prompts and mini-games, and also to automate event announcements.",
      category: "DevOps/Automation",
      languages: [
        {
          name: "Python",
          iconifyClass: "logos:python",
        },
        {
          name: "Discord",
          iconifyClass: "logos:discord-icon",
        },
      ],
      links: [
        {
          name: "Github",
          url: "https://github.com/osc-vitap/OSC-DBot",
          iconifyClass: "ri:github-fill",
        },
      ],
    },
    {
      id: "10",
      name: "NPM-package-updater",
      url: "https://github.com/SVijayB/NPM-package-updater",
      description:
        "Given a list of Node.js GitHub repositories, the app checks if a specified dependency meets the provided version. If it's lower, users can opt to update it through automated pull requests.",
      category: "DevOps/Automation",
      languages: [
        {
          name: "Python",
          iconifyClass: "logos:python",
        },
        {
          name: "Flask",
          iconifyClass: "simple-icons:flask",
        },
        {
          name: "HTML5",
          iconifyClass: "vscode-icons:file-type-html",
        },
      ],
      links: [
        {
          name: "Github",
          url: "https://github.com/SVijayB/NPM-package-updater",
          iconifyClass: "ri:github-fill",
        },
      ],
    },
    {
      id: "11",
      name: "Custom-notepad",
      url: "https://github.com/SVijayB/Custom-notepad",
      description:
        "Built a custom notepad to overcome the default one's feature limitations. It includes advanced features like dark mode, temporary data saving, text formatting, and more!",
      category: "Miscellaneous",
      languages: [
        {
          name: "Python",
          iconifyClass: "logos:python",
        },
      ],
      links: [
        {
          name: "Github",
          url: "https://github.com/SVijayB/Custom-notepad",
          iconifyClass: "ri:github-fill",
        },
        {
          name: "Releases",
          url: "https://github.com/SVijayB/Custom-notepad/releases/tag/v1.0.0",
          iconifyClass: "hugeicons:package-sent",
        },
      ],
    },
    {
      id: "12",
      name: "Lock & Unlock PC using RFID",
      url: "https://github.com/SVijayB/Lock_Unlock_A_Computer_Using_RFID",
      description:
        "A compact Arduino and C project that utilizes an RFID card to lock and unlock computers, simplifying password entry and facilitating the use of complex passwords effortlessly.",
      category: "Miscellaneous",
      languages: [
        {
          name: "Arduino",
          iconifyClass: "logos:arduino",
        },
        {
          name: "RFID",
          iconifyClass: "ri:rfid-line",
        },
        {
          name: "C",
          iconifyClass: "hugeicons:c-programming",
        },
      ],
      links: [
        {
          name: "Github",
          url: "https://github.com/SVijayB/Lock_Unlock_A_Computer_Using_RFID",
          iconifyClass: "ri:github-fill",
        },
      ],
    },
    {
      id: "13",
      name: "Steam WebScraper",
      url: "https://github.com/SVijayB/Steam_WebScraper",
      description:
        "This app monitors Steam market values of CSGO items using web scraping. It alerts users when prices drop below a set threshold, saving money and time.",
      category: "DevOps/Automation",
      languages: [
        {
          name: "Python",
          iconifyClass: "logos-python",
        },
      ],
      links: [
        {
          name: "Github",
          url: "https://github.com/SVijayB/Steam_WebScraper",
          iconifyClass: "ri:github-fill",
        },
        {
          name: "Releases",
          url: "https://github.com/SVijayB/Steam_WebScraper/releases",
          iconifyClass: "hugeicons:package-sent",
        },
      ],
    },
  ],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "vijay.jpeg",
    description:
      "You can contact me through any of the social links below. I'll try to get back to you as soon as possible!",
  },
  blogSection: {
    title: "Blogs",
    subtitle: `I write blogs on a wide range of topics, including life events, academic and project experiences, life principles, and general rants.`,
    link: "https://blog.vijaybalaji.com/",
    avatar_image_path: "blogs_image.svg",
  },
};

export {
  settings,
  greeting,
  socialMediaLinks,
  skills,
  degrees,
  certifications,
  experience,
  projectsHeader,
  contactPageData,
  projects,
};
